export default "__VITE_ASSET__B0eC6FwZ__"